/*
 * @Author: 黄贺林
 * @Date: 2024-06-19 09:31:20
 * @LastEditTime: 2024-07-13 11:05:20
 * @Description: 在此处清晰,简洁的说明本文件的作用
 */
import { getoauthToken, loginWithAccessToken } from '@/api/login'

import router from '@/router'
import Vue from 'vue'

const vm = Vue.prototype

const user = {
  state: {
    access_token: null,
    application_name: null,
    uploadCenter_token: null,
    uploadCenter_user_info: null,
    uploadCenter_en_language: 'en',
    loading: false,
    isOnline: true,
    isDark: false,  //  是否深色模式
    fileList: [], //  上传文件数据
    downloadFileList: []  //  下载文件数据
  },
  mutations: {
    SET_TOKEN (state, data) {
      state.uploadCenter_token = data
    },
    SET_USER_INFO (state, data) {
      state.uploadCenter_user_info = data
    },
    LOG_OUT (state) {
      state.uploadCenter_token = null,
        state.uploadCenter_user_info = null
      //去登录页
      window.location.href = `${process.env.VUE_APP_CASDOOR_URL}/api/logout?post_logout_redirect_uri=${location.origin}${process.env.VUE_APP_BASE_URL}&state= ${state.application_name}&id_token_hint=${state.access_token}`
      state.access_token = null,
        state.application_name = null
    },
    async GET_OAUTH_TOKEN (state, data) {
      state.access_token = data.access_token
      state.application_name = data.application_name
      state.uploadCenter_token = data.uploadCenter_token
      state.uploadCenter_user_info = data.uploadCenter_user_info
      router.push('/')
    },
    SET_GET_LANGUAGE (state, data) {
      state.uploadCenter_en_language = data
    },
    SET_LOADING (state, data) {
      state.loading = data
    },
    SET_ISONLINE (state, data) {
      state.isOnline = data
    },
    SET_IS_DARK (state, data) {
      state.isDark = data
    },
    SET_FILE_LIST (state, data) {
      state.fileList = data
    },
    SET_DOWNLOAD_FILE_LIST (state, data) {
      state.downloadFileList = data
    },
  },
  actions: {
    SET_TOKEN ({ commit }, data) {
      commit('SET_TOKEN', data)
    },
    SET_USER_INFO ({ commit }, data) {
      commit('SET_USER_INFO', data)
    },
    // casdoor退登逻辑
    LOG_OUT ({ commit }, data) {
      commit('LOG_OUT')
    },
    SET_GET_LANGUAGE ({ commit }, data) {
      commit('SET_GET_LANGUAGE', data)
    },
    // casdoor登录逻辑
    GET_OAUTH_TOKEN ({ commit }, data) {
      let datas = {}
      commit('SET_LOADING', true)
      getoauthToken({ code: data.code }).then((res) => {
        if (res.code) {
          datas.access_token = res.data.access_token
          datas.application_name = res.data.state
          loginWithAccessToken({ access_token: res.data.access_token, device_type: 'web' }).then(res => {
            if (res.code) {
              datas.uploadCenter_token = res.data.token
              datas.uploadCenter_user_info = res.data.user
              commit('GET_OAUTH_TOKEN', datas)
              commit('SET_LOADING', false)
              vm.$message({
                message: res.msg,
                type: "success",
              });
            }
          })
        }
      })
    },
  },
  getters: {
    GET_TOKEN: (state) => state.uploadCenter_token,
    GET_USER_INFO: (state) => state.uploadCenter_user_info,
    GET_LANGUAGE: (state) => state.uploadCenter_en_language,
    GET_LOADING: (state) => state.loading,
    GET_ISONLINE: (state) => state.isOnline,
    GET_IS_DARK: (state) => state.isDark
  }
}

export default user